
// import React, { useState, useEffect } from 'react';
// import { postData } from '../../../../Services/Fetchnodeservices';
// import { X, Save, Sparkles, Trash2 } from 'lucide-react';
// import ImageSearchModal from './ImageSearchModal';

// const EditItemModal = ({ isOpen, onClose, item, designationId, onUpdate, ts }) => {
//     const [formData, setFormData] = useState(null);
//     const [saving, setSaving] = useState(false);
//     const [showImageFinder, setShowImageFinder] = useState(false);

//     useEffect(() => {
//         if (item) {
//             const variants = Array.isArray(item.variant) ? item.variant : JSON.parse(item.variant || '[]');
//             const processed = variants.map(v => ({
//                 ...v,
//                 actual_price: v.actual_price || (parseFloat(v.item_price_variant) / 1.2).toFixed(0)
//             }));
//             setFormData({ ...item, variant: processed });
//         }
//     }, [item]);

//     const calculateCustomerPrice = (menuP) => Math.round((parseFloat(menuP) || 0) * 1.20);

//     const handleSave = async () => {
//         setSaving(true);
//         try {
//             const finalVariants = formData.variant.map(v => ({
//                 ...v,
//                 actual_price: parseFloat(v.actual_price) || 0,
//                 item_price_variant: calculateCustomerPrice(v.actual_price),
//                 unit: (v.unit_value || "Price").toLowerCase(),
//                 is_available_variant: "yes"
//             }));

//             const finalItem = {
//                 ...formData,
//                 variant: finalVariants,
//                 requested_price: finalVariants[0]?.actual_price || 0,
//                 price: finalVariants[0]?.item_price_variant || 0
//             };

//             const resp = await postData(`menu/update-menu/${designationId}/${item.product_id}`, finalItem, 'PUT');
//             if (resp.success) { onUpdate(); onClose(); }
//         } catch (e) { alert(e.message); }
//         finally { setSaving(false); }
//     };

//     if (!isOpen || !formData) return null;

//     const styles = {
//         overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' },
//         modal: { background: ts.surface, width: '95%', maxWidth: '500px', borderRadius: '24px', border: `1px solid ${ts.border}`, color: ts.textPrimary, overflow: 'hidden', backgroundImage: ts.gradientCard },
//         input: { width: '100%', padding: '12px', borderRadius: '12px', background: ts.background, border: `1px solid ${ts.border}`, color: ts.textPrimary, marginBottom: '15px', outline: 'none' },
//         vRow: { display: 'flex', gap: '10px', alignItems: 'center', background: ts.surfaceLighter, padding: '12px', borderRadius: '15px', marginBottom: '10px', border: `1px solid ${ts.border}` }
//     };

//     return (
//         <div style={styles.overlay}>
//             <div style={styles.modal}>
//                 <div style={{ padding: '20px', borderBottom: `1px solid ${ts.border}`, display: 'flex', justifyContent: 'space-between' }}>
//                     <h3 style={{ margin: 0 }}>Edit Luxury Item</h3>
//                     <button onClick={onClose} style={{ background: 'none', border: 'none', color: ts.textMuted }}><X /></button>
//                 </div>
//                 <div style={{ padding: '24px', maxHeight: '70vh', overflowY: 'auto' }}>
//                     <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
//                         <div style={{ textAlign: 'center' }}>
//                             <img src={formData.pic1?.startsWith('http') ? formData.pic1 : `https://zaptodoor.com/uploads/${formData.pic1}`} style={{ width: '100px', height: '100px', borderRadius: '16px', objectFit: 'cover' }} />
//                             <button onClick={()=>setShowImageFinder(true)} style={{ marginTop: '8px', background: ts.primary, color: 'black', border: 'none', padding: '5px 10px', borderRadius: '8px', fontSize: '10px', fontWeight: 'bold', cursor: 'pointer' }}><Sparkles size={10}/> AI Search</button>
//                         </div>
//                         <div style={{ flex: 1 }}>
//                             <input style={styles.input} value={formData.name} onChange={e=>setFormData({...formData, name:e.target.value})} placeholder="Item Name" />
//                             <select style={styles.input} value={formData.is_veg} onChange={e=>setFormData({...formData, is_veg: e.target.value})}>
//                                 <option value="yes">Veg</option><option value="no">Non-Veg</option>
//                             </select>
//                         </div>
//                     </div>
//                     <textarea style={{ ...styles.input, height: '60px' }} value={formData.description} onChange={e=>setFormData({...formData, description:e.target.value})} placeholder="Description" />
                    
//                     <div style={{display:'flex', justifyContent:'space-between', marginBottom:'10px'}}><label style={{fontSize:'12px', fontWeight:700}}>PRICING (MENU PRICE)</label><button onClick={()=>setFormData({...formData, variant: [...formData.variant, {unit_value:'', actual_price:0}]})} style={{color:ts.primary, background:'none', border:'none', fontSize:'12px', cursor:'pointer'}}>+ Add Price</button></div>
                    
//                     {formData.variant.map((v, i) => (
//                         <div key={i} style={styles.vRow}>
//                             <input style={{...styles.input, marginBottom:0, flex:1.5}} placeholder="Unit" value={v.unit_value} onChange={e=>{let nv=[...formData.variant]; nv[i].unit_value=e.target.value; setFormData({...formData, variant:nv})}} />
//                             <input style={{...styles.input, marginBottom:0, flex:1}} type="number" placeholder="Menu ₹" value={v.actual_price} onChange={e=>{let nv=[...formData.variant]; nv[i].actual_price=e.target.value; setFormData({...formData, variant:nv})}} />
//                             <div style={{flex:1, textAlign:'right'}}><div style={{fontSize:'10px', color:ts.textMuted}}>App Price</div><div style={{color:ts.success, fontWeight:700}}>₹{calculateCustomerPrice(v.actual_price)}</div></div>
//                             <button onClick={()=>{let nv=formData.variant.filter((_,idx)=>idx!==i); setFormData({...formData, variant:nv})}} style={{ color: ts.error, background: 'none', border: 'none' }}><Trash2 size={16}/></button>
//                         </div>
//                     ))}
//                 </div>
//                 <div style={{ padding: '20px', borderTop: `1px solid ${ts.border}`, display: 'flex', gap: '10px' }}>
//                     <button onClick={onClose} style={{ flex: 1, padding: '12px', borderRadius: '12px', border: `1px solid ${ts.border}`, background: 'none', color: ts.textSecondary }}>Cancel</button>
//                     <button onClick={handleSave} disabled={saving} style={{ flex: 2, padding: '12px', borderRadius: '12px', background: ts.primary, color: 'black', border: 'none', fontWeight: 700 }}>{saving ? "Updating..." : "Save Luxury Item"}</button>
//                 </div>
//             </div>
//             {showImageFinder && <ImageSearchModal isOpen={showImageFinder} onClose={()=>setShowImageFinder(false)} query={formData.name} onSelect={img=>{setFormData({...formData, pic1:img}); setShowImageFinder(false);}} />}
//         </div>
//     );
// };

// export default EditItemModal;

import React, { useState, useEffect } from 'react';
import { postData, serverURL } from '../../../../Services/Fetchnodeservices';
import { X, Save, Sparkles, Trash2 } from 'lucide-react';
import ImageSearchModal from './ImageSearchModal';

const EditItemModal = ({ isOpen, onClose, item, designationId, onUpdate, ts }) => {
    const [formData, setFormData] = useState(null);
    const [saving, setSaving] = useState(false);
    const [showImageFinder, setShowImageFinder] = useState(false);

    useEffect(() => {
        if (item) {
            // Parse variants safely
            let variants = [];
            try {
                variants = Array.isArray(item.variant) ? item.variant : JSON.parse(item.variant || '[]');
            } catch (e) {
                variants = [];
            }

            // 🔥 FIX: If actual_price is missing, set it to item_price_variant (treat as menu)
            // This will show the correct menu price in the input field
            const processed = variants.map(v => ({
                ...v,
                actual_price: v.actual_price || parseFloat(v.item_price_variant || v.price) || 0
            }));

            // Item-level fallback (if no variants, use requested_price or price)
            let itemLevelMenu = parseFloat(item.requested_price) || 0;
            if (!itemLevelMenu) {
                itemLevelMenu = parseFloat(item.price) || 0; // use price as menu if requested_price missing
            }

            setFormData({
                ...item,
                requested_price: itemLevelMenu,
                price: parseFloat(item.price) || 0,
                variant: processed
            });
        }
    }, [item]);

    // Customer price = menu * 1.2
    const calculateCustomerPrice = (menuP) => {
        const menu = parseFloat(menuP) || 0;
        return Math.round(menu * 1.20);
    };

    const handleSave = async () => {
        setSaving(true);
        try {
            // Process each variant: actual_price is menu, item_price_variant = menu * 1.2
            const finalVariants = formData.variant.map(v => {
                const menuPrice = parseFloat(v.actual_price) || 0;
                const custPrice = calculateCustomerPrice(menuPrice);
                return {
                    ...v,
                    actual_price: menuPrice,
                    item_price_variant: custPrice,
                    price: custPrice, // backward compatibility
                    unit: (v.unit_value || "Price").toLowerCase(),
                    is_available_variant: "yes"
                };
            });

            // Item-level prices from first variant if exists
            let itemRequestedPrice = 0;
            let itemPrice = 0;
            if (finalVariants.length > 0) {
                itemRequestedPrice = finalVariants[0].actual_price;
                itemPrice = finalVariants[0].item_price_variant;
            } else {
                itemRequestedPrice = parseFloat(formData.requested_price) || 0;
                itemPrice = calculateCustomerPrice(itemRequestedPrice);
            }

            const finalItem = {
                ...formData,
                variant: finalVariants,
                requested_price: itemRequestedPrice,
                price: itemPrice,
                is_veg: formData.is_veg || 'yes'
            };

            console.log('Saving item:', finalItem);

            const resp = await postData(`menu/update-menu/${designationId}/${item.product_id}`, finalItem, 'PUT');
            if (resp.success) {
                onUpdate();
                onClose();
            } else {
                alert('Update failed: ' + (resp.message || 'Unknown error'));
            }
        } catch (e) {
            console.error('Save error:', e);
            alert('Error: ' + e.message);
        }
        finally { setSaving(false); }
    };

    if (!isOpen || !formData) return null;

    // Styles (using ts prop for theme)
    const styles = {
        overlay: {
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.85)',
            zIndex: 10000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        modal: {
            background: ts.surface,
            width: '95%',
            maxWidth: '500px',
            borderRadius: '24px',
            border: `1px solid ${ts.border}`,
            color: ts.textPrimary,
            overflow: 'hidden',
            backgroundImage: ts.gradientCard
        },
        input: {
            width: '100%',
            padding: '12px',
            borderRadius: '12px',
            background: ts.background,
            border: `1px solid ${ts.border}`,
            color: ts.textPrimary,
            marginBottom: '15px',
            outline: 'none'
        },
        vRow: {
            display: 'flex',
            gap: '10px',
            alignItems: 'center',
            background: ts.surfaceLighter,
            padding: '12px',
            borderRadius: '15px',
            marginBottom: '10px',
            border: `1px solid ${ts.border}`
        }
    };

    return (
        <div style={styles.overlay}>
            <div style={styles.modal}>
                <div style={{
                    padding: '20px',
                    borderBottom: `1px solid ${ts.border}`,
                    display: 'flex',
                    justifyContent: 'space-between'
                }}>
                    <h3 style={{ margin: 0 }}>✏️ Edit Item</h3>
                    <button onClick={onClose} style={{ background: 'none', border: 'none', color: ts.textMuted }}>
                        <X />
                    </button>
                </div>
                <div style={{ padding: '24px', maxHeight: '70vh', overflowY: 'auto' }}>
                    <div style={{ display: 'flex', gap: '20px', marginBottom: '20px' }}>
                        <div style={{ textAlign: 'center' }}>
                            <img
                                src={formData.pic1?.startsWith('http') ? formData.pic1 : `${serverURL}/uploads/${formData.pic1}`}
                                style={{ width: '100px', height: '100px', borderRadius: '16px', objectFit: 'cover' }}
                                onError={e => e.target.src = "https://via.placeholder.com/100"}
                            />
                            <button
                                onClick={() => setShowImageFinder(true)}
                                style={{
                                    marginTop: '8px',
                                    background: ts.primary,
                                    color: 'black',
                                    border: 'none',
                                    padding: '5px 10px',
                                    borderRadius: '8px',
                                    fontSize: '10px',
                                    fontWeight: 'bold',
                                    cursor: 'pointer'
                                }}
                            >
                                <Sparkles size={10}/> AI Search
                            </button>
                        </div>
                        <div style={{ flex: 1 }}>
                            <input
                                style={styles.input}
                                value={formData.name || ''}
                                onChange={e => setFormData({...formData, name: e.target.value})}
                                placeholder="Item Name"
                            />
                            <select
                                style={styles.input}
                                value={formData.is_veg || 'yes'}
                                onChange={e => setFormData({...formData, is_veg: e.target.value})}
                            >
                                <option value="yes">Veg</option>
                                <option value="no">Non-Veg</option>
                            </select>
                        </div>
                    </div>
                    <textarea
                        style={{ ...styles.input, height: '60px' }}
                        value={formData.description || ''}
                        onChange={e => setFormData({...formData, description: e.target.value})}
                        placeholder="Description"
                    />

                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <label style={{ fontSize: '12px', fontWeight: 700 }}>💲 PRICING (MENU PRICE)</label>
                        <button
                            onClick={() => setFormData({
                                ...formData,
                                variant: [...formData.variant, { unit_value: '', actual_price: 0 }]
                            })}
                            style={{ color: ts.primary, background: 'none', border: 'none', fontSize: '12px', cursor: 'pointer' }}
                        >
                            + Add Price
                        </button>
                    </div>

                    {formData.variant.map((v, i) => (
                        <div key={i} style={styles.vRow}>
                            <input
                                style={{ ...styles.input, marginBottom: 0, flex: 1.5 }}
                                placeholder="Unit (e.g. Half, Full)"
                                value={v.unit_value || ''}
                                onChange={e => {
                                    let nv = [...formData.variant];
                                    nv[i].unit_value = e.target.value;
                                    setFormData({...formData, variant: nv});
                                }}
                            />
                            <input
                                style={{ ...styles.input, marginBottom: 0, flex: 1 }}
                                type="number"
                                placeholder="Menu ₹"
                                value={v.actual_price || ''}
                                onChange={e => {
                                    let nv = [...formData.variant];
                                    nv[i].actual_price = parseFloat(e.target.value) || 0;
                                    setFormData({...formData, variant: nv});
                                }}
                            />
                            <div style={{ flex: 1, textAlign: 'right' }}>
                                <div style={{ fontSize: '10px', color: ts.textMuted }}>App Price</div>
                                <div style={{ color: ts.success, fontWeight: 700 }}>
                                    ₹{calculateCustomerPrice(v.actual_price)}
                                </div>
                            </div>
                            <button
                                onClick={() => {
                                    let nv = formData.variant.filter((_, idx) => idx !== i);
                                    setFormData({...formData, variant: nv});
                                }}
                                style={{ color: ts.error, background: 'none', border: 'none' }}
                            >
                                <Trash2 size={16} />
                            </button>
                        </div>
                    ))}
                </div>
                <div style={{
                    padding: '20px',
                    borderTop: `1px solid ${ts.border}`,
                    display: 'flex',
                    gap: '10px'
                }}>
                    <button
                        onClick={onClose}
                        style={{
                            flex: 1,
                            padding: '12px',
                            borderRadius: '12px',
                            border: `1px solid ${ts.border}`,
                            background: 'none',
                            color: ts.textSecondary
                        }}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSave}
                        disabled={saving}
                        style={{
                            flex: 2,
                            padding: '12px',
                            borderRadius: '12px',
                            background: ts.primary,
                            color: 'black',
                            border: 'none',
                            fontWeight: 700
                        }}
                    >
                        {saving ? "Updating..." : "💾 Save Item"}
                    </button>
                </div>
            </div>

            {showImageFinder && (
                <ImageSearchModal
                    isOpen={showImageFinder}
                    onClose={() => setShowImageFinder(false)}
                    query={formData.name}
                    onSelect={img => {
                        setFormData({...formData, pic1: img});
                        setShowImageFinder(false);
                    }}
                />
            )}
        </div>
    );
};

export default EditItemModal;